import axios from 'axios';

export async function getLoanOfficers() {
  try {
    return await axios.get(`${process.env.REACT_APP_MCCC_API_URL}/refi/loan-officers`);
  } catch (error) {
    return error?.response?.status;
  }
}

export async function getSelectedLO(loId) {
  try {
    return await axios.get(`${process.env.REACT_APP_MCCC_API_URL}/refi/loan-officer-details/${loId}`);
  } catch (error) {
    return error?.response?.status;
  }
}
